// extracted by mini-css-extract-plugin
export default {"container":"IconsBlocks_container__Zlxa6","iconWrap":"IconsBlocks_iconWrap__IxlxY"};